var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [_vm._v("Persona " + _vm._s(_vm.form.nombre))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "form",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.datos_persona_resumida,
                    expression: "!datos_persona_resumida"
                  }
                ],
                attrs: {
                  method: "post",
                  enctype: "multipart/form-data",
                  action: _vm.urlImportacion
                }
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "hidden", name: "_token", id: "_token" },
                  domProps: { value: _vm.token }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tipoFiltro === "",
                    expression: "tipoFiltro === ''"
                  }
                ],
                staticClass: "card"
              },
              [
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "form-inline" }, [
                    _c("label", { attrs: { for: "clt" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.es_cliente,
                            expression: "form.es_cliente"
                          }
                        ],
                        attrs: { type: "checkbox", id: "clt" },
                        domProps: {
                          checked: Array.isArray(_vm.form.es_cliente)
                            ? _vm._i(_vm.form.es_cliente, null) > -1
                            : _vm.form.es_cliente
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.form.es_cliente,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "es_cliente",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "es_cliente",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "es_cliente", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Cliente")])
                    ]),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "proveedor" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.es_proveedor,
                            expression: "form.es_proveedor"
                          }
                        ],
                        attrs: { type: "checkbox", id: "proveedor" },
                        domProps: {
                          checked: Array.isArray(_vm.form.es_proveedor)
                            ? _vm._i(_vm.form.es_proveedor, null) > -1
                            : _vm.form.es_proveedor
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.form.es_proveedor,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "es_proveedor",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "es_proveedor",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "es_proveedor", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Proveedor")])
                    ]),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "transportistaP" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.es_transportista,
                            expression: "form.es_transportista"
                          }
                        ],
                        attrs: { type: "checkbox", id: "transportistaP" },
                        domProps: {
                          checked: Array.isArray(_vm.form.es_transportista)
                            ? _vm._i(_vm.form.es_transportista, null) > -1
                            : _vm.form.es_transportista
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.form.es_transportista,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "es_transportista",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "es_transportista",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "es_transportista", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Transportista")])
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.searchButton &&
                      (_vm.permiteEditarPersona || _vm.permiteEliminarPersona),
                    expression:
                      "searchButton && (permiteEditarPersona || permiteEliminarPersona)"
                  }
                ]
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn-info btn--bigger",
                    attrs: { type: "button" },
                    on: { click: _vm.buscarPersona }
                  },
                  [
                    _c("i", { staticClass: "fa fa-search" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Buscar")])
                  ]
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { autocomplete: "off", method: "POST" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "layout__main" }, [
            _c("div", { staticClass: "layout__main-form" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                type: "text",
                                id: "nombre",
                                placeholder: "Ingrese nombre completo"
                              },
                              model: {
                                value: _vm.form.nombre,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "nombre", $$v)
                                },
                                expression: "form.nombre"
                              }
                            },
                            [
                              _c("span", [_vm._v("Nombre *")]),
                              _vm._v(" "),
                              _vm.errores.nombre
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.errores.nombre[0]))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                      _c("div", { staticClass: "form-inline" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "natural" } }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.tipo_persona,
                                expression: "form.tipo_persona"
                              }
                            ],
                            attrs: { type: "radio", id: "natural", value: "N" },
                            domProps: {
                              checked: _vm._q(_vm.form.tipo_persona, "N")
                            },
                            on: {
                              change: [
                                function($event) {
                                  return _vm.$set(_vm.form, "tipo_persona", "N")
                                },
                                _vm.cargarTiposIdentificacion
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Natural")])
                        ]),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "juridica" } }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.tipo_persona,
                                expression: "form.tipo_persona"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              id: "juridica",
                              value: "J"
                            },
                            domProps: {
                              checked: _vm._q(_vm.form.tipo_persona, "J")
                            },
                            on: {
                              change: [
                                function($event) {
                                  return _vm.$set(_vm.form, "tipo_persona", "J")
                                },
                                _vm.cargarTiposIdentificacion
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Jurídica")])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                      _c("div", { staticClass: "form-field select2" }, [
                        _c(
                          "div",
                          { staticClass: "select2-field" },
                          [
                            _c("v-select", {
                              attrs: {
                                tooltip:
                                  _vm.selectedTipoIdentificacion !== null
                                    ? _vm.selectedTipoIdentificacion.descripcion
                                    : "Seleccione...",
                                options: _vm.tiposIdentificacion,
                                placeholder: "Seleccione...",
                                label: "descripcion"
                              },
                              model: {
                                value: _vm.selectedTipoIdentificacion,
                                callback: function($$v) {
                                  _vm.selectedTipoIdentificacion = $$v
                                },
                                expression: "selectedTipoIdentificacion"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "tipoIdentificacion" } },
                              [_vm._v("Tipo de identificación *")]
                            ),
                            _vm._v(" "),
                            _vm.errores.id_tipo_identificacion
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errores.id_tipo_identificacion[0]
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: _vm.formatoIdentificacion,
                                  expression: "formatoIdentificacion"
                                }
                              ],
                              attrs: {
                                readonly: _vm.tieneNumeroPorDefecto,
                                type: "tel",
                                id: "cedulaRuc",
                                placeholder: "Ingrese Ced/Ruc"
                              },
                              on: { input: _vm.inputIdentificacion },
                              model: {
                                value: _vm.form.identificacion,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "identificacion", $$v)
                                },
                                expression: "form.identificacion"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v("Número de identificación *")
                              ]),
                              _vm._v(" "),
                              _vm.errores.identificacion
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.identificacion[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.datos_persona_resumida,
                            expression: "!datos_persona_resumida"
                          }
                        ],
                        staticClass: "col-xs-12 col-md-4"
                      },
                      [
                        _c("div", { staticClass: "form-inline" }, [
                          _vm._m(2),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "masculino" } }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.sexo,
                                  expression: "form.sexo"
                                }
                              ],
                              attrs: {
                                type: "radio",
                                id: "masculino",
                                value: "M"
                              },
                              domProps: { checked: _vm._q(_vm.form.sexo, "M") },
                              on: {
                                change: function($event) {
                                  return _vm.$set(_vm.form, "sexo", "M")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Masculino")])
                          ]),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "femenino" } }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.sexo,
                                  expression: "form.sexo"
                                }
                              ],
                              attrs: {
                                type: "radio",
                                id: "femenino",
                                value: "F"
                              },
                              domProps: { checked: _vm._q(_vm.form.sexo, "F") },
                              on: {
                                change: function($event) {
                                  return _vm.$set(_vm.form, "sexo", "F")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Femenino")])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.datos_persona_resumida,
                            expression: "!datos_persona_resumida"
                          }
                        ],
                        staticClass: "col-xs-12 col-md-4"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  vMoney: "",
                                  format: _vm.int,
                                  type: "text",
                                  id: "telefono",
                                  placeholder: "Ingrese el teléfono"
                                },
                                model: {
                                  value: _vm.form.telefono,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "telefono", $$v)
                                  },
                                  expression: "form.telefono"
                                }
                              },
                              [_c("span", [_vm._v("Teléfono")])]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                type: "text",
                                id: "email",
                                placeholder: "Ingrese el email"
                              },
                              model: {
                                value: _vm.form.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "email", $$v)
                                },
                                expression: "form.email"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v('E-mail * ("," para separar varios)')
                              ]),
                              _vm._v(" "),
                              _vm.errores.email
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.errores.email[0]))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.datos_persona_resumida,
                            expression: "!datos_persona_resumida"
                          }
                        ],
                        staticClass: "col-xs-12 col-md-4"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  type: "text",
                                  id: "contacto",
                                  placeholder: "Ingrese contacto"
                                },
                                model: {
                                  value: _vm.form.contacto,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "contacto", $$v)
                                  },
                                  expression: "form.contacto"
                                }
                              },
                              [_c("span", [_vm._v("Contacto")])]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.datos_persona_resumida,
                            expression: "!datos_persona_resumida"
                          }
                        ],
                        staticClass: "col-xs-12 col-md-4"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  type: "text",
                                  id: "comentario",
                                  placeholder: "Ingrese comentario"
                                },
                                model: {
                                  value: _vm.form.comentario,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "comentario", $$v)
                                  },
                                  expression: "form.comentario"
                                }
                              },
                              [_c("span", [_vm._v("Comentario")])]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                type: "text",
                                id: "direccion",
                                placeholder: "Ingrese dirección"
                              },
                              model: {
                                value: _vm.form.direccion,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "direccion", $$v)
                                },
                                expression: "form.direccion"
                              }
                            },
                            [
                              _c("span", [_vm._v("Dirección *")]),
                              _vm._v(" "),
                              _vm.errores.direccion
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.errores.direccion[0]))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.datos_persona_resumida,
                            expression: "!datos_persona_resumida"
                          }
                        ],
                        staticClass: "col-xs-12 col-md-4"
                      },
                      [
                        _c("div", { staticClass: "form-field select2" }, [
                          _c(
                            "div",
                            { staticClass: "select2-field" },
                            [
                              _c("v-select", {
                                attrs: {
                                  tooltip:
                                    _vm.selectedPais !== null
                                      ? _vm.selectedPais.nombre
                                      : "Seleccione...",
                                  options: _vm.paises,
                                  placeholder: "Seleccione...",
                                  label: "nombre"
                                },
                                model: {
                                  value: _vm.selectedPais,
                                  callback: function($$v) {
                                    _vm.selectedPais = $$v
                                  },
                                  expression: "selectedPais"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "pais" } }, [
                                _vm._v("País *")
                              ])
                            ],
                            1
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.datos_persona_resumida,
                            expression: "!datos_persona_resumida"
                          }
                        ],
                        staticClass: "col-xs-12 col-md-4"
                      },
                      [
                        _c("div", { staticClass: "form-field select2" }, [
                          _c(
                            "div",
                            { staticClass: "select2-field" },
                            [
                              _c("v-select", {
                                attrs: {
                                  tooltip:
                                    _vm.selectedProvincia !== null
                                      ? _vm.selectedProvincia.nombre
                                      : "Seleccione...",
                                  options: _vm.provincias,
                                  placeholder: "Seleccione...",
                                  label: "nombre"
                                },
                                model: {
                                  value: _vm.selectedProvincia,
                                  callback: function($$v) {
                                    _vm.selectedProvincia = $$v
                                  },
                                  expression: "selectedProvincia"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "provincia" } }, [
                                _vm._v("Provincia *")
                              ])
                            ],
                            1
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.datos_persona_resumida,
                            expression: "!datos_persona_resumida"
                          }
                        ],
                        staticClass: "col-xs-12 col-md-4"
                      },
                      [
                        _c("div", { staticClass: "form-field select2" }, [
                          _c(
                            "div",
                            { staticClass: "select2-field" },
                            [
                              _c("v-select", {
                                attrs: {
                                  tooltip:
                                    _vm.selectedCiudad !== null
                                      ? _vm.selectedCiudad.nombre
                                      : "Seleccione...",
                                  options: _vm.ciudades,
                                  placeholder: "Seleccione...",
                                  label: "nombre"
                                },
                                model: {
                                  value: _vm.selectedCiudad,
                                  callback: function($$v) {
                                    _vm.selectedCiudad = $$v
                                  },
                                  expression: "selectedCiudad"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "ciudad" } }, [
                                _vm._v("Ciudad *")
                              ]),
                              _vm._v(" "),
                              _vm.errores.id_ciudad
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.errores.id_ciudad[0]))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.datos_persona_resumida,
                            expression: "!datos_persona_resumida"
                          }
                        ],
                        staticClass: "col-xs-12 col-md-4"
                      },
                      [
                        _c("div", { staticClass: "form-inline" }, [
                          _c(
                            "label",
                            { attrs: { for: "obligado_contabilidad" } },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.obligado_contabilidad,
                                    expression: "form.obligado_contabilidad"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: "obligado_contabilidad"
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.form.obligado_contabilidad
                                  )
                                    ? _vm._i(
                                        _vm.form.obligado_contabilidad,
                                        null
                                      ) > -1
                                    : _vm.form.obligado_contabilidad
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.form.obligado_contabilidad,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form,
                                            "obligado_contabilidad",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form,
                                            "obligado_contabilidad",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.form,
                                        "obligado_contabilidad",
                                        $$c
                                      )
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v("Obligado a llevar contabilidad")
                              ])
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.datos_persona_resumida,
                            expression: "!datos_persona_resumida"
                          }
                        ],
                        staticClass: "col-xs-12 col-md-8"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "input-field",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.generarClave,
                                    expression: "!generarClave"
                                  }
                                ],
                                attrs: {
                                  type: _vm.tipoClave,
                                  id: "clave_portal",
                                  placeholder: "Ingrese la clave"
                                },
                                model: {
                                  value: _vm.form.clave_portal,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "clave_portal", $$v)
                                  },
                                  expression: "form.clave_portal"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v("Clave de portal de acceso *")
                                ]),
                                _vm._v(" "),
                                _vm.errores.clave_portal
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.errores.clave_portal[0])
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "input-field",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.generarClave,
                                    expression: "generarClave"
                                  }
                                ],
                                attrs: {
                                  readonly: "",
                                  type: _vm.tipoClave,
                                  id: "clave_generada",
                                  placeholder: "Ingrese la clave"
                                },
                                model: {
                                  value: _vm.form.clave_portal,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "clave_portal", $$v)
                                  },
                                  expression: "form.clave_portal"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v("Clave de portal de acceso *")
                                ]),
                                _vm._v(" "),
                                _vm.errores.clave_portal
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.errores.clave_portal[0])
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "generarClave" } }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.generarClave,
                                    expression: "generarClave"
                                  }
                                ],
                                attrs: { type: "checkbox", id: "generarClave" },
                                domProps: {
                                  checked: Array.isArray(_vm.generarClave)
                                    ? _vm._i(_vm.generarClave, null) > -1
                                    : _vm.generarClave
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$a = _vm.generarClave,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.generarClave = $$a.concat([
                                              $$v
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.generarClave = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.generarClave = $$c
                                      }
                                    },
                                    _vm.generarClavePortal
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Generar clave")])
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.generarClave,
                                    expression: "generarClave"
                                  }
                                ],
                                staticClass: "btn-secondary",
                                attrs: { type: "button" },
                                on: { click: _vm.generarClavePortal }
                              },
                              [_c("i", { staticClass: "fa fa-refresh" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-info",
                                attrs: { type: "button" },
                                on: { click: _vm.verClave }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa",
                                  class: {
                                    "fa-eye": _vm.claveOculta,
                                    "fa-eye-slash": !_vm.claveOculta
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.datos_persona_resumida,
                            expression: "!datos_persona_resumida"
                          }
                        ],
                        staticClass: "col-xs-12 col-md-4"
                      },
                      [
                        _c("div", { staticClass: "form-inline" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.contribuyente_especial,
                                  expression: "form.contribuyente_especial"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                id: "contribuyente_especial"
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.form.contribuyente_especial
                                )
                                  ? _vm._i(
                                      _vm.form.contribuyente_especial,
                                      null
                                    ) > -1
                                  : _vm.form.contribuyente_especial
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.form.contribuyente_especial,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.form,
                                          "contribuyente_especial",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.form,
                                          "contribuyente_especial",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.form,
                                      "contribuyente_especial",
                                      $$c
                                    )
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Contribuyente Especial")])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.datos_persona_resumida,
                            expression: "!datos_persona_resumida"
                          }
                        ],
                        staticClass: "col-xs-12 col-md-4"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.form.contribuyente_especial,
                                    expression: "form.contribuyente_especial"
                                  }
                                ],
                                attrs: {
                                  type: "text",
                                  id: "titulo",
                                  placeholder: "Ingrese el número"
                                },
                                model: {
                                  value: _vm.form.numero_cont_espec,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "numero_cont_espec", $$v)
                                  },
                                  expression: "form.numero_cont_espec"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v("Número de contribuyente especial")
                                ]),
                                _vm._v(" "),
                                _vm.errores.numero_cont_espec
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errores.numero_cont_espec[0]
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.datos_persona_resumida,
                            expression: "!datos_persona_resumida"
                          }
                        ],
                        staticClass: "col-xs-12 col-md-6 col-lg-4"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: "#",
                                    expression: "'#'"
                                  }
                                ],
                                attrs: {
                                  type: "tel",
                                  id: "decimales_compras",
                                  placeholder: "#"
                                },
                                model: {
                                  value: _vm.form.decimales_compras,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "decimales_compras", $$v)
                                  },
                                  expression: "form.decimales_compras"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Decimales en compras\n                  "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "layout__main-buttons" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card__content" }, [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            (_vm.permiteCrearPersona && _vm.estado === "N") ||
                            (_vm.permiteEditarPersona && _vm.estado !== "N"),
                          expression:
                            "(permiteCrearPersona && estado === 'N') || (permiteEditarPersona && estado !== 'N')"
                        }
                      ],
                      staticClass: "btn-success",
                      attrs: { type: "button" },
                      on: { click: _vm.submit }
                    },
                    [
                      _c("i", { staticClass: "fa fa-save" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Guardar")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.permiteCrearPersona && _vm.closable,
                          expression: "permiteCrearPersona && closable"
                        }
                      ],
                      staticClass: "btn-light btn--text",
                      attrs: { type: "button" },
                      on: { click: _vm.crearPersona }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Nueva")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.permiteEliminarPersona,
                          expression: "permiteEliminarPersona"
                        }
                      ],
                      staticClass: "btn--text",
                      class: {
                        "btn-danger": _vm.estado === "A" || _vm.estado === "N",
                        "btn-success": _vm.estado === "I"
                      },
                      attrs: { disabled: _vm.estado === "N", type: "button" },
                      on: { click: _vm.anularPersona }
                    },
                    [
                      _c("i", { staticClass: "fa fa-ban" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.estado === "I" ? "Re-activar" : "Bloquear")
                        )
                      ])
                    ]
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "60%",
            height: "auto",
            scrollable: true,
            name: "listaPersonas"
          }
        },
        [
          _c("lista-personas", {
            ref: "listaPersonas",
            attrs: { createButton: _vm.createButton },
            on: {
              selected: _vm.cargarPersonaSeleccionada,
              cerrarModal: _vm.cerrarModal
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-inline" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("input", { attrs: { type: "file", name: "archivo", id: "archivo" } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("button", { staticClass: "btn-success" }, [
          _c("i", { staticClass: "fa fa-upload" }),
          _c("span", [_vm._v("Importar")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("p", [_c("strong", [_vm._v("Tipo de persona *")])])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("p", [_c("strong", [_vm._v("Sexo *")])])])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44294b38", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44294b38","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/personas/Persona.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-44294b38","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/personas/Persona.vue
// module chunks = 0